module.exports = __webpack_public_path__ + "images/emoji/car.90a07a0f9db952bd9523.png";